import { Chip } from "@heroui/react";
import { useState, useEffect } from "react";
import { OfficeLocation } from "@/api/locations/locations.ts";
import { useAppSelector } from "@/hooks/useAppSelector.ts";

export function LocationChip({ locationId }: { locationId: number }) {
  const [item, setItem] = useState<OfficeLocation | null>(null);
  const items = useAppSelector((state) => state.handbooks.location);

  useEffect(() => {
    if (locationId === -1) {
      setItem(null);
    } else {
      setItem(items.find((el) => el.id == locationId) || null);
    }
  }, [locationId, items]);

  return (
    <>
      {locationId === -1 && (
        <Chip variant="dot" color="danger">
          удалено
        </Chip>
      )}
      {locationId !== -1 && item !== null && (
        <Chip className="cursor-pointer" variant="dot" color="primary">
          {item?.display_name}
        </Chip>
      )}
      {locationId !== -1 && item == null && (
        <Chip variant="dot" color="default">
          н/д
        </Chip>
      )}
    </>
  );
}
